import React from 'react';
import { Box, keyframes } from '@mui/material';

const shimmerAnimation = keyframes`
  0% {
    background-position: -200% center;
  }
  100% {
    background-position: 200% center;
  }
`;

interface ShimmerTextProps {
  text: string;
}

const background = `linear-gradient(90deg, var(--color-content-base-tertiary) 0%, var(--color-surface-base-tertiary) 10.89%, var(--color-content-base-tertiary) 19.03%)`;
const ShimmerText: React.FC<ShimmerTextProps> = ({ text }) => (
  <Box
    component="span"
    sx={{
      alignSelf: 'center',
      fontSize: 14,
      fontWeight: 600,
      background,
      backgroundSize: '200% auto',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      animation: `${shimmerAnimation} 3s linear infinite reverse`,
    }}>
    {text}
  </Box>
);

export default ShimmerText;
